export const environment = {
    version: '1.0.0',
    tenantId: '',
    production: true,
    urlApi: 'https://portal-bff-prd.silgov.io'
}
